module.exports = __webpack_public_path__ + "media/images/iatp-507090ed165dcd35c0d6baf6edf4711f.png";